import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function HeroSection() {
  const { ref: heroRef, isVisible } = useScrollReveal<HTMLElement>({ threshold: 0.1 });

  return (
    <section ref={heroRef} className={`relative min-h-screen bg-axelia-bg overflow-hidden transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="w-full px-6 md:px-10 lg:px-16 pt-24 md:pt-32 pb-16 md:pb-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-6 min-h-[calc(100vh-8rem)]">
          {/* Left Content - 40% */}
          <div className={`w-full lg:w-[42%] flex flex-col items-start text-left transition-all duration-1000 delay-200 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
            <span className="inline-block px-4 py-1.5 border border-axelia-text/20 rounded-full text-xs font-medium text-axelia-text-secondary tracking-widest mb-6 md:mb-8">
              INNOVATION &amp; TECHNOLOGY
            </span>

            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-[3.2rem] font-bold text-axelia-text leading-[1.25] tracking-tight mb-6">
              人と組織の成長から、
              <br />
              <span className="italic font-normal text-axelia-accent">未来を創る</span>
            </h1>

            <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9] max-w-md mb-8 md:mb-10">
              AXELIA株式会社は、人と組織の可能性を引き出し、
              人材育成コンサルティングを起点に、
              システムエンジニアリングやWeb制作まで、
              幅広い技術と創造の力を提供します。
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#services"
                className="px-7 py-3.5 text-sm font-medium bg-axelia-text text-white rounded-full hover:bg-axelia-accent transition-colors duration-300 whitespace-nowrap"
              >
                事業内容を見る
              </a>
              <a
                href="#contact"
                className="px-7 py-3.5 text-sm font-medium border border-axelia-text/30 text-axelia-text rounded-full hover:bg-axelia-text hover:text-white transition-all duration-300 whitespace-nowrap"
              >
                お問い合わせ
              </a>
            </div>
          </div>

          {/* Right Content - 58% */}
          <div className={`w-full lg:w-[58%] relative transition-all duration-1000 delay-500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
            <div className="relative aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5] max-h-[600px] lg:max-h-[700px] rounded-[2rem] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20scientific%20visualization%20of%20microscopic%20particles%20and%20dust%20structures%20floating%20in%20warm%20neutral%20toned%20space%20with%20soft%20amber%20and%20cream%20lighting%2C%20elegant%20minimal%20composition%20with%20geometric%20subtle%20patterns%2C%20highly%20detailed%20digital%20art%20illustration%20suitable%20for%20technology%20company%20website%20hero%20background%2C%20sophisticated%20and%20intellectual%20atmosphere%20with%20warm%20charcoal%20and%20ivory%20palette&width=800&height=1000&seq=axelia-hero-01&orientation=portrait"
                alt="AXELIA - 科学と技術の融合"
                className="w-full h-full object-cover object-top"
              />
              {/* Overlay gradient for subtle depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-axelia-text/10 via-transparent to-transparent" />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
